export default "__VITE_ASSET__DBWlr7HP__"